import { getIsFaceCollageEnabledForScene } from "./getIsFaceCollageEnabledForScene.js";
const sceneTypeToComplexity = {
    /*
     * intro
     */
    birthdayCakeIntro: 1,
    birthdayCandlesIntro: 1,
    // this intro has a video/animation
    inkyGuestBookIntro: 3,
    generalSolidIntro: 1,
    bigCongratsIntro: 1,
    schoolSpiritIntro: 2,
    meadowFlowersIntro: 1,
    mountainViewIntro: 1,
    paintDaubsIntro: 1,
    /*
     * outro
     */
    outro: 3,
    lottieOutro: 3,
    popHeartsOutro: 1,
    /*
     * greeting
     */
    greeting: 3,
    typeOnGreeting: 1,
    greetingLinesAsScenes: 1,
    circleGreeting: 1,
    /*
     * misc
     */
    "clip-series-basic": 2,
    lottie: 3,
    imageSequence: 1,
    textTransition: 1,
};
/**
 * This function still needs to be implemented
 * more fully, but in general complexity is a measure
 * of how many times longer it takes to render a scene
 * compared to realtime of the scene. For example, a
 * clipSeries scene might take 2x longer to render than
 * the duration of the scene, so its complexity would be 2.
 *
 * We should do more targeted experiments to determine the
 * actual complexity of each of these scenes.
 */
export function getSceneComplexity(scene, renderConfig) {
    // Face Collage automatically increases complexity due to
    // rendering multiple clips in a single scene
    if (getIsFaceCollageEnabledForScene("faceCollage" in scene ? scene.faceCollage : undefined, renderConfig)) {
        return 3;
    }
    return sceneTypeToComplexity[scene.type];
}
